import {sendPostRequest} from "./index";
import {apiBooking} from "./api/booking";

export const sendBookingSim = (data: any) => sendPostRequest(apiBooking.createBook, data);
